export default __webpack_public_path__ + "static/media/RobotoCondensed-Bold.12c8ddb8.ttf";